export class ObjectifPro {
    id: number;
    name: string;
}


